import React from 'react';
export interface SliderCtaProps {
  text: string;
  customClass?: string;
  link: string;
}

const SliderCta: React.FC<SliderCtaProps> = ({ link, customClass = '', text, ...props }) => {
  return (
    <>
      {link ? (
        <button
          className={`text-slider-ctaText bg-slider-ctaBg ripple border border-slider-ctaBorder flex font-medium md:font-medium justify-center leading-16 items-center min-h-40 py-10 px-20 text-center text-16 rounded-5 ${customClass}`}
          font-customisation="para-text"
          button-customisation="banner-button"
          {...props}
        >
          <a href={link} className="">
            {text || 'Shop Now'}
          </a>
        </button>
      ) : null}
    </>
  );
};

export default SliderCta;
